export const PRODUCT_TYPES_RESET_STATE = 'PRODUCT_TYPES_RESET_STATE';
export const PRODUCT_TYPES_CURRENT_ITEM = 'PRODUCT_TYPES_CURRENT_ITEM';

export const PRODUCT_TYPES_REQUEST_LOADING = 'PRODUCT_TYPES_REQUEST_LOADING';
export const PRODUCT_TYPES_REQUEST_SUCCESS = 'PRODUCT_TYPES_REQUEST_SUCCESS';
export const PRODUCT_TYPES_REQUEST_FAILED = 'PRODUCT_TYPES_REQUEST_FAILED';

export const PRODUCT_TYPES_CURRENT_ACTION = 'PRODUCT_TYPES_CURRENT_ACTION';
export const PRODUCT_TYPES_RESET_ACTION = 'PRODUCT_TYPES_RESET_ACTION';